import React, { useState, useEffect } from 'react';
import { GoogleMap, LoadScript, Marker, InfoWindow } from '@react-google-maps/api';
import { GOOGLE_API_TOKEN, HOSTEL_LOCATION } from '../../common/constants';
import HostelLocation from './HostelLocation';


const MapContainer = () => {

  const mapStyles = {
    height: "350px",
    width: "100%"
  };


  const defaultCenter = {
    lat: HOSTEL_LOCATION.lat, lng: HOSTEL_LOCATION.lng
  }
  // Locations for markers 
  const locations = [
    //Hosel location 
    {
      name: "Oripando Hostel",
      location: {
        lat: HOSTEL_LOCATION.lat,
        lng: HOSTEL_LOCATION.lng
      },
    }
  ];

  const [selected, setSelected] = useState({});
  const [currentPosition, setCurrentPosition] = useState({});

  const success = position => {
    // const currentPosition = {
    //   lat: position.coords.latitude,
    //   lng: position.coords.longitude
    // }
    const currentPosition = {
      name: "Your location",
      location: {
        lat: position.coords.latitude,
        lng: position.coords.longitude
      }
    }
    // locations.push(userLocation)
    setCurrentPosition(currentPosition);
  };

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(success);
  })
  const onSelect = item => {
    setSelected(item);
  }

  return (
    <LoadScript className="common-map-container"
      googleMapsApiKey={GOOGLE_API_TOKEN}>
      <GoogleMap
        mapContainerStyle={mapStyles}
        zoom={19}
        center={defaultCenter}
      >
        {
          locations.map(item => {
            return (
              <Marker key={item.name} position={item.location} onClick={() => onSelect(item)} />
            )
          })
        }

        {
          selected.location &&
          (
            <InfoWindow
              position={selected.location}
              clickable={true}
              onCloseClick={() => setSelected({})}
            >
              <p>{selected.name}</p>
            </InfoWindow>
          )
        }
        {/* {
          currentPosition.location && currentPosition.location.lat &&
          (
            <Marker key={currentPosition.name} position={currentPosition.location} onClick={() => onSelect(currentPosition)} />
          )
        } */}

      </GoogleMap>
    </LoadScript>
  )
}

export default MapContainer;


// WEBPACK FOOTER //
// ./src/features/common/MapContainer.js